import type { MessageKey } from '@reos/i18n';

/**
 * Krok MAIL1 bod 3 — JEDNA hláška „e-mail se neodeslal" pro VŠECHNY cesty.
 *
 * Tentýž důvod se objeví na třech obrazovkách: podpisový panel (odkaz
 * k podpisu), klientský formulář (odkaz na doplnění údajů) a karta e-mailu na
 * tabuli Úkoly (odpověď). Kdyby si každá vybírala hlášku sama, rozešly by se —
 * a makléř by na jedné obrazovce viděl „odesílání je vypnuté" a na druhé
 * „nepodařilo se", ačkoli jde o tentýž stav.
 *
 * Co se tu NEDĚJE: nic se nepřekládá tady. Funkce vrací KLÍČE katalogu, text
 * skládá `t()` v komponentě (cs je zdrojový jazyk, `en` má paritu).
 */

/** Důvody, které server posílá v `blockReason` / `notDeliveredReason`. */
const KNOWN_REASONS = [
  'odesilani-vypnute',
  'hodinovy-strop',
  'duplicitni-zprava',
  'odesilatel-nenastaven',
  'odeslani-selhalo',
  // Krok D1 bod 1: DEMO kancelar — server vrati `ukazka` u e-mailu i u SMS.
  'ukazka',
  // Krok P6A: SMS na cislo mimo povolene prijemce pilotu. Jediny duvod, ktery
  // mluvi o SMS, ne o e-mailu — makler musi poznat, ze odkaz/kod ma predat
  // jinak, ne ze „to zkusi za chvili" jako u hodinoveho stropu.
  'cislo-mimo-pilot',
] as const;

export type ClientMailReason = (typeof KNOWN_REASONS)[number];

/**
 * Klíč hlášky k důvodu. Neznámý kód (novější server, starší bundle) skončí na
 * neutrálním „E-mail se neodeslal." — nikdy na prázdném místě, kde by makléř
 * myslel, že zpráva odešla.
 */
export function clientMailReasonKey(reason: string | null | undefined): MessageKey {
  const known = (KNOWN_REASONS as readonly string[]).includes(reason ?? '')
    ? (reason as ClientMailReason)
    : 'neznamy';
  return `webAdmin.clientMail.reason.${known}` as MessageKey;
}

/** `true` = u téhle cesty má smysl nabídnout „Kopírovat odkaz" (odkaz existuje). */
export const CLIENT_MAIL_COPY_HINT_KEY = 'webAdmin.clientMail.copyLinkHint' as MessageKey;
